import { useTranslation } from 'react-i18next';

const SKIP_TARGET_ID = 'main-content';

/**
 * Keyboard-only "skip to content" link. First focusable element in the DOM
 * so Tab from the address bar lands here, then a single Enter jumps past
 * the shell chrome (sidebars, headers) straight into the routed page.
 *
 * Visually hidden until focused — sighted mouse users never see it.
 */
export function SkipToContent() {
  const { t, i18n } = useTranslation();
  const label = i18n.exists('a11y.skipToContent')
    ? t('a11y.skipToContent')
    : 'Ga direct naar inhoud';

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const target = document.getElementById(SKIP_TARGET_ID);
    if (!target) return;
    e.preventDefault();
    // tabIndex=-1 makes the wrapper programmatically focusable without
    // adding it to the natural tab order.
    target.focus({ preventScroll: false });
    target.scrollIntoView({ block: 'start' });
  };

  return (
    <a
      href={`#${SKIP_TARGET_ID}`}
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-foreground focus:shadow-lg focus:ring-2 focus:ring-primary focus:outline-none"
    >
      {label}
    </a>
  );
}

export const SKIP_TO_CONTENT_TARGET_ID = SKIP_TARGET_ID;
